import {dispatchStatus, DispatchStatus} from "@ots-frontend/ots-data";
import {useMemo} from "react";
import {Progress, ProgressProps} from "../Progress/Progress";
import {getDispatchStatusColorRef} from "../../../util/dispatch-ui-util";
import {useTranslation} from "react-i18next";

export type DispatchProgressProps = Omit<ProgressProps, 'color' | 'value' | 'label' | 'sections'> & {
  status: DispatchStatus
  pickup?: boolean
}

export const DispatchProgress = (props: DispatchProgressProps) => {
  const {status, pickup = false, ...rest} = props

  const {t} = useTranslation(["common"])

  const color = useMemo(() => {
    return getDispatchStatusColorRef(status, pickup)
  }, [status, pickup])

  const value = useMemo(() => {
    switch (status) {
      case dispatchStatus.pending:
        return 10
      case dispatchStatus.started:
        if (pickup) {
          return 65
        } else {
          return 35
        }
      case dispatchStatus.canceled:
      case dispatchStatus.completed:
        return 100
      default:
        return
    }
  }, [status, pickup])

  const label = useMemo(() => {
    if (status === dispatchStatus.started && pickup) {
      return "Picked-Up"
    } else {
      return t(status.displayValue.id, status.displayValue.defaultMessage)
    }
  }, [t, status, pickup])

  return (<Progress {...rest} color={color} value={value} label={label}/>)
}
